export default __webpack_public_path__ + "static/media/dor-na-barriga.3d9bdb9f.png";